module.exports = __webpack_public_path__ + "img/trailer.b04260ef.svg";